import angular from "angular";
import "../../../../services/cart";
import "../../../../services/product";
import "../../../../filters/sum";
import _ from "lodash";
import "./cart-product-options";

angular.module("folkeuni").component("cartProduct", {
  templateUrl: "/shop-dist/templates/cart-product.html",
  bindings: {
    product: "<",
    onUpdate: "&",
    state: "<",
    siteId: "<",
  },
  controller: function (Cart, Product) {
    var $ctrl = this;

    $ctrl.ticketTypes = [];
    $ctrl.productModel = null;
    $ctrl.showOptionsModal = false;

    $ctrl.$onInit = function () {
      Product.getProductById($ctrl.siteId, $ctrl.product.id).then(
        function (product) {
          console.dir(product);
          $ctrl.productModel = product;
          $ctrl.ticketTypes = getTicketTypes();
        },
        function (errorResponse) {}
      );
    };

    $ctrl.changeTicketCount = function (ticketType, newCount) {
      newCount = parseInt(newCount, 10);
      if (isNaN(newCount) || newCount < 0) newCount = 0;
      updateCart(newCount, ticketType.type);
    };

    $ctrl.incrementTicket = function (ticketType) {
      $ctrl.changeTicketCount(ticketType, ticketType.count + 1);
    };

    $ctrl.decrementTicket = function (ticketType) {
      $ctrl.changeTicketCount(ticketType, ticketType.count - 1);
    };

    $ctrl.openOptionsModal = function () {
      $ctrl.showOptionsModal = true;
    };
    $ctrl.closeOptionsModal = function (selected) {
      $ctrl.showOptionsModal = false;
      // Her kan du håndtere valgte tilvalg hvis nødvendigt
    };

    function updateCart(quantity, type) {
      $ctrl.state.loading = true;

      Cart.update({
        productId: $ctrl.product.id,
        courseId: $ctrl.product.courseId,
        type: type,
        quantity: quantity,
      }).then(
        function (cart) {
          if (window.Clerk != null) {
            window.Clerk("cart", "remove", $ctrl.product.id); //TODO tjek om denne logik holder
          }

          $ctrl.ticketTypes = getTicketTypes();

          $ctrl.state.loading = false;
        },
        function (res) {
          $ctrl.state.loading = false;
        }
      );
    }

    function getTicketTypes() {
      if (!$ctrl.productModel || !$ctrl.productModel.prices) {
        return [];
      }
      // Returnér alle typer fra prices, men count fra tickets hvis muligt
      const grouped = _.groupBy($ctrl.product.tickets || [], "type");
      var types = $ctrl.productModel.prices.map((priceObj) => {
        return {
          type: priceObj.type,
          name: getTicketTypeName(priceObj.type),
          price: priceObj.value,
          count: (grouped[priceObj.type] || []).length,
        };
      });

      $ctrl.product.ticketTypes = types;

      return types;
    }

    function getTicketTypeName(type) {
      const names = {
        Normal: "Standard",
        Student: "Studerende",
        KeyAccount: "Special aftale"
      };
      return names[type] || type;
    }

    $ctrl.$onChanges = function (changes) {
      if (changes.product) {
        $ctrl.ticketTypes = getTicketTypes();
      }
    };
  },
});
